__turbopack_context__.v({
  "carouselWrapper": "RecommendedTemplatesCarousel-module-scss-module__vkZDHa__carouselWrapper",
  "desktopCardInner": "RecommendedTemplatesCarousel-module-scss-module__vkZDHa__desktopCardInner",
  "mobileCardInner": "RecommendedTemplatesCarousel-module-scss-module__vkZDHa__mobileCardInner",
  "mobileScrollContainer": "RecommendedTemplatesCarousel-module-scss-module__vkZDHa__mobileScrollContainer",
  "mobileSlide": "RecommendedTemplatesCarousel-module-scss-module__vkZDHa__mobileSlide",
  "navButton": "RecommendedTemplatesCarousel-module-scss-module__vkZDHa__navButton",
  "scrollContainer": "RecommendedTemplatesCarousel-module-scss-module__vkZDHa__scrollContainer",
  "slide": "RecommendedTemplatesCarousel-module-scss-module__vkZDHa__slide",
  "staticGrid": "RecommendedTemplatesCarousel-module-scss-module__vkZDHa__staticGrid",
});
